const WORDS_PER_MINUTE = 200;

/** Estimated reading time in whole minutes (min 1) for markdown/HTML content. */
export function readingTimeMinutes(content: string | null | undefined): number {
  if (!content) return 1;
  const text = content
    .replace(/<[^>]+>/g, " ")
    .replace(/[#*_`>\-[\]()!|]/g, " ")
    .trim();
  if (!text) return 1;
  const words = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / WORDS_PER_MINUTE));
}

export function readingTimeLabel(content: string | null | undefined, suffix = "min"): string {
  return `${readingTimeMinutes(content)} ${suffix}`;
}
